import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronDown, ChevronUp } from "lucide-react";

const ServiceArea = [
  { label: "Büyükçekmece Koltuk Yıkama", path: "/buyukcekmece/buyukcekmece-koltuk-yikama" },
  { label: "Büyükçekmece Yorgan Yıkama", path: "/buyukcekmece/buyukcekmece-yorgan-yikama" },
  { label: "Büyükçekmece Battaniye Yıkama", path: "/buyukcekmece/buyukcekmece-battaniye-yikama" },
  { label: "Büyükçekmece Perde Yıkama", path: "/buyukcekmece/buyukcekmece-perde-yikama" },
  { label: "Büyükçekmece Kuru Temizleme", path: "/buyukcekmece/buyukcekmece-kuru-temizleme" },
  { label: "Büyükçekmece Yerinde Yıkama", path: "/buyukcekmece/buyukcekmece-yerinde-yikama" },
  { label: "Mimaroba Koltuk Yıkama", path: "/buyukcekmece/mimaroba-koltuk-yikama" },
  { label: "Mimaroba Perde Yıkama", path: "/buyukcekmece/mimaroba-perde-yikama" },
  { label: "Kumburgaz Koltuk Yıkama", path: "/buyukcekmece/kumburgaz-koltuk-yikama" },
  { label: "Kumburgaz Yerinde Yıkama", path: "/buyukcekmece/kumburgaz-yerinde-yikama" }
];

const BuyukcekmeceServiceArea = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="text-[#003132] mt-0 w-full">
      <div
        onClick={toggleDropdown}
        className="cursor-pointer flex items-center justify-between bg-[#e2e8f0] p-3 rounded-lg shadow-md hover:bg-[#d1d5db]"
      >
        <h2 className="text-lg font-semibold uppercase tracking-wide">
          BÜYÜKÇEKMECE HİZMET TÜRLERİ
        </h2>
        {isOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
      </div>

      {isOpen && (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-3 bg-[#f1f5f9] p-5 rounded-xl shadow-sm border border-gray-200 w-full mt-2">
          {ServiceArea.map((area, index) => (
            <Link
              key={index}
              to={area.path}
              className={`text-sm font-semibold px-4 py-3 rounded-lg text-center transition-all duration-200 ${
                location.pathname === area.path
                  ? "bg-green-700 text-white"
                  : "bg-white text-green-900 hover:bg-green-100 hover:text-green-800"
              }`}
            >
              {area.label}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default BuyukcekmeceServiceArea;
